export const AREA_COLORS = {
  red: {
    fill: "rgba(220, 38, 38, 0.3)",
    stroke: "rgba(220, 38, 38, 0.8)",
  },
  green: {
    fill: "rgba(0, 128, 0, 0.3)",
    stroke: "rgba(0, 128, 0, 0.8)",
  },
  orange: {
    fill: "rgba(255, 165, 0, 0.3)",
    stroke: "rgba(255, 165, 0, 0.8)",
  },
  blue: {
    fill: "rgba(21, 50, 138, 0.3)",
    stroke: "rgba(21, 50, 138, 0.8)",
  },
  white: {
    fill: "rgba(255, 255, 255, 0.3)",
    stroke: "rgba(200, 200, 200, 0.8)",
  },
} as const;

export const BADGE_COLOR = "rgba(18, 100, 224, 0.8)";
